// eslint-disable-next-line no-undef
const object = ccObject

export const lockBody = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  const body = document.body
  body.classList.add('body-locked')
  body.style.overflow = 'hidden'
  body.style.paddingRight = `${width}px`
  body.style.setProperty('--body-spacing', `${width}px`)
  const header = document.querySelector('.site-header')
  header.style.paddingRight = `${width}px`

  return width
}

export const unlockBody = () => {
  const body = document.body
  const header = document.querySelector('.site-header')
  body.classList.remove('menu-active')
  header.style.paddingRight = ''
  body.style.overflow = ''
  body.style.paddingRight = ''
  body.style.setProperty('--body-spacing', '0px')
}

export const debounce = (fn, threshold) => {
  var timeout
  threshold = threshold || 100
  return function debounced() {
    clearTimeout(timeout)
    var args = arguments
    var _this = this
    function delayed() {
      fn.apply(_this, args)
    }
    timeout = setTimeout(delayed, threshold)
  }
}

export const getTextNodesIn = (node) => {
  let textNodes = []
  let nodeStack = [node]

  while (nodeStack.length > 0) {
    const currentNode = nodeStack.pop()
    if (currentNode.nodeType === Node.TEXT_NODE) {
      textNodes.push(currentNode)
    } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
      const children = currentNode.childNodes
      for (let i = children.length - 1; i >= 0; i--) {
        nodeStack.push(children[i])
      }
    }
  }

  return textNodes
    .map((node) => node.textContent.trim())
    .join('')
    .replace(/\s+/g, ' ')
}

export const modalAlertTemplate = (args) => {
  return `<div class="modal modal-alert ${args.classes}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        ${object.loader}
                        <p>${args.body}</p>
                    </div>
                </div>
            </div>
        </div>`
}
